<template>
   <div class="similar-answers">
        <div class="headline">{{ isAnswer ? '相关问答' : '相关文章' }}</div>
        <div class="" v-if="similarList.length">
            <ul class="similar-answers-lists">
              <li v-for="(item,index) in similarList" class="similar-item" :key="index">
                <div class="left-info">
                  <img src="../../images/community/eye-open.png" alt="">
                  <p>{{item.no_of_views}}</p>
                </div>
                <div @click="goQuestionList(item)" class="right-words">{{item.title}}</div>
              </li>
          </ul>
        </div>
        <loading :ifLoadingStart="isSimilarLoading" style="padding: 100px 0;background-color:#ffffff;margin:0;"></loading>
        <div class="attention-null" v-if="!isSimilarLoading && this.similarList.length === 0">
            <img src="../../images/developer/null.png" alt="" />
            <p>未有相关问答！</p>
        </div>
    </div>
</template>
<script>
import loading from "../loading.vue";
export default {
  components: {
    loading
  },
  props: {
    isAnswer: {
      type: Boolean,
      default: true
    },
    tags: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      similarList: [],
      isSimilarLoading: true
    }
  },
  mounted () {
    this.initRightContent();
  },
  methods: {
    initRightContent () {
      const tagsName = this.tags.map(item => item.title).join(',')
      let url = `forum/topics/?board=${this.isAnswer ? 'qa' : 'article'}&tags=${tagsName}`
      axios.get( myUrl + url).then(res => {
          if (!res.data.result) return;
          this.isSimilarLoading = false;
          this.similarList = res.data.data.results;
            
      },
        reject => {
            this.options = {
                msgText: "操作成功！",
                msgIsSuccess: true
            };
          }
        );
    },
    goQuestionList(item) {
      let routeData = this.$router.resolve({
        name: 'Question',
        params: {
          wid: item.id
        },
        query: {
          type: this.$route.query.type
        }
      })
      window.open(routeData.href, '_blank')
    },
  }
}
</script>

<style lang="scss" scoped type="text/scss">
    .similar-answers {
        padding: 0 20px 20px;
        background-color: #ffffff;
        font-size: 14px;
        .headline{
          height: 52px;
          line-height: 52px;
          color: #313238;
          font-weight: 700;
          border-bottom: 1px solid #f0f1f5;
        }
        .attention-null {
          text-align: center !important;
          padding: 62px !important;
          margin: 0 !important;
          p {
            font-size: 14px !important;
            margin-top: 10px;
          }
        }
        .similar-answers-lists {
          margin-top: 16px;
          .similar-item {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            color: #979ba5;
            &:last-child {
              margin-bottom: 0;
            }
            .left-info {
              padding: 6px 5px 3px;
              min-width: 40px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              background: #f0f1f5;
              border-radius: 2px;
              font-size: 12px;
              margin-right: 16px;
              color: #63656e;
              img {
                height: 16px;
                width: 16px;
              }
            }
            .right-words {
              flex: 1;
              font-size: 12px;
              color: #63656e;
              cursor: pointer;
              line-height: 16px;
              display: -webkit-box;
              text-overflow: ellipsis;
              overflow: hidden;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              &:hover {
                color: #3a84ff;
              }
            }
          }
        }
      }
</style>




// WEBPACK FOOTER //
// communityRightContent.vue?ae7c3d2e